<template>
	<div class="flex flex-col c-box" :class="fullscreen ? 'c-box-fullscreen' : 'c-box'"  @click.stop>
		<div :class="fullscreen ? 'header-box-fullscreen' : 'header-box'">
			<p style="width: 90%; margin: 0 auto" :title="title"  class="nowrap">
				{{title  }}
			</p>
			<div class="fullScreen" @click="goNewPage()">
				<div class="iconfont icon-style" v-if="fullscreen">&#xe749;</div>
				<div class="iconfont icon-style" v-else>&#xe60f;</div>
			</div>
			<div class="close-box" @click="closePreview">×</div>
		</div>
		<div class="centent-box">
			<div class="pdf-wrap" :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'" v-show="((previewType.toLowerCase() === 'pdf' || previewType === 'doc' || (previewType === 'docx' && defaultGraph === false )))">
				<iframe ref="iframe" width="100%" :src="previewUrl" name="123" scrolling-y="auto" frameborder="0" style="width: 100%; height: 100%; background: #fff"></iframe>
			</div >
			 <div  :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"  v-show="(
					           (previewType === 'jpg' ||
					            previewType === 'png' ||
					            previewType === 'jpeg' ||
					            previewType === 'bmp') )">
								<img class="img-preview" :src="previewUrl" alt="" />
			</div>
			<div  :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"  v-show="(previewType === 'mp4' || previewType === 'MP4') ">
				<video style="height: 100%; width: 100%" controls controlsList="nodownload" autoplay="autoplay" :src="previewUrl"></video>
			</div>
	   </div>
</div>
			
</template>

<script>
import { getAction, postAction  } from "@/api/index";
export default{
	mounted(){
		
	},
	props: {
			previewType: {
				type: String,
			},
			previewUrl: {
				type: String,
			},
			title:{
				type: String,
			},
    },
	data(){
		return {
			fullscreen:false,
			defaultGraph:false,
		}
	},
	methods: {
		closePreview() {
				this.$emit("closePreview");
//				if(this.fullscreen) {
//					this.goNewPage();
//				}
		}, 
		goNewPage() {
				let element = document.documentElement;
				if(this.fullscreen) {
					if(document.exitFullscreen) {
						document.exitFullscreen();
					} else if(document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if(document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if(document.msExitFullscreen) {
						document.msExitFullscreen();
					}
				} else {
					if(element.requestFullscreen) {
						element.requestFullscreen();
					} else if(element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if(element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if(element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
				}
				this.fullscreen = !this.fullscreen;
				this.$emit("goNewPage", this.fullscreen);
	     },
	}
}
</script>
<style scoped lang="scss">
     *{
     	font-size: 18px;
     }
	.img-box {
		width: 15px;
		height: 17px;
		margin-right: 8px;
	}
	
	.img-box-min {
		width: 10px;
		height: 12px;
		margin-right: 8px;
	}
	.img-preview{
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 100%;
			position: absolute;
			margin: auto;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
	   }
	   .img-preview-box {
		position: relative;
		max-height: 718px;
		overflow: hidden;
		width:100%;
		height:500px;
		/*background: #000;*/
	   }
	.c-box {
		width: 100%;
		height: 100%;
		background: url("../../assets/images/img19.png") no-repeat;
		background-size: 100% 100%;
	}
	
	.c-box-fullscreen {
		width: 100%;
		height: 100%;
		background: #fff;
		/* background: url("../../assets/images/img19.png") no-repeat;
  background-size: 100% 100%;*/
	}
	.fullScreen {
		color: #fff;
		position: absolute;
		right: 7%;
		top: 2px;
		z-index: 99;
		cursor: pointer;
	}
	
	.icon-style {
		font-size: 25px;
	}
	.header-box-fullscreen {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	
	.header-box {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		margin: 0px 19px 0px 9px;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	.pdf-wrap{
		width:100%;
		height:100%;
	}
	.img-preview-box-fullscreen {
		position: relative;
		overflow: hidden;
		height: 100%;
		background: #000;
	}
	.centent-box {
		margin: 0 12px 5px 0;
		padding: 10px 25px;
		height: 90%;
		overflow: auto;
		.box-item{
			margin:20px auto;
			/deep/ .ant-descriptions-item-label{
				width:120px;
			}
			/deep/ .ant-descriptions-item-content{
				width:240px;
			}
		}
    }
	.close-box {
		position: absolute;
		color: #fff;
		font-size: 40px;
		right: 3%;
		cursor: pointer;
		top: -2px;
	}	
</style>